import { Link } from "react-router-dom";
import {
  MapPin,
  Phone,
  Mail,
  Clock,
} from "lucide-react";
import { COMPANY, NAV, CATEGORIES, BRANDS } from "../data/site";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-border bg-background"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 lg:py-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
        {/* Brand */}
        <div className="lg:col-span-4 space-y-5">
          <div className="inline-flex items-center bg-white px-4 py-2 rounded-sm">
            <img
              src="/brand/rns-logo-wide.png"
              alt="RNS Automobile"
              className="h-16 w-auto object-contain"
            />
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed max-w-sm">
            Your trusted destination for premium automobile spare parts —
            specialising in Mahindra, Maruti Suzuki and Tata components with
            quality you can rely on.
          </p>
          <div className="pt-2 text-[11px] uppercase tracking-overline text-muted-foreground">
            Est. Berhampore · West Bengal · India
          </div>
        </div>

        {/* Quick Links */}
        <div className="lg:col-span-2">
          <h4 className="text-xs uppercase tracking-overline font-bold text-muted-foreground mb-4">
            Company
          </h4>
          <ul className="space-y-2.5 text-sm">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  className="hover:text-[#C8102E] transition-colors duration-200"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Categories */}
        <div className="lg:col-span-3">
          <h4 className="text-xs uppercase tracking-overline font-bold text-muted-foreground mb-4">
            Product Categories
          </h4>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
            {CATEGORIES.slice(0, 8).map((c) => (
              <li key={c.key}>
                <Link
                  to={`/products#${c.key}`}
                  className="hover:text-[#C8102E] transition-colors duration-200"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-5 pt-4 border-t border-border">
            <h5 className="text-xs uppercase tracking-overline font-bold text-muted-foreground mb-3">
              Brands
            </h5>
            <div className="flex flex-wrap gap-2">
              {BRANDS.map((b) => (
                <span
                  key={b.key}
                  className="text-[11px] uppercase tracking-overline border border-border px-2 py-1"
                >
                  {b.name}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Contact */}
        <div className="lg:col-span-3">
          <h4 className="text-xs uppercase tracking-overline font-bold text-muted-foreground mb-4">
            Reach Us
          </h4>
          <ul className="space-y-3.5 text-sm">
            <li className="flex gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-[#C8102E] shrink-0" />
              <a
                href={COMPANY.mapView}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-address-link"
                className="leading-relaxed hover:text-[#C8102E] transition-colors duration-200"
              >
                {COMPANY.address.line1}, {COMPANY.address.city},{" "}
                {COMPANY.address.state} – {COMPANY.address.pin}
              </a>
            </li>
            <li className="flex gap-3">
              <Phone className="h-4 w-4 mt-0.5 text-[#C8102E] shrink-0" />
              <div className="space-y-0.5">
                {COMPANY.phones.map((p) => (
                  <a
                    key={p.link}
                    href={`tel:${p.link}`}
                    className="block hover:text-[#C8102E]"
                  >
                    {p.display}
                  </a>
                ))}
              </div>
            </li>
            <li className="flex gap-3">
              <Mail className="h-4 w-4 mt-0.5 text-[#C8102E] shrink-0" />
              <a
                href={`mailto:${COMPANY.email}`}
                className="hover:text-[#C8102E] break-all"
              >
                {COMPANY.email}
              </a>
            </li>
            <li className="flex gap-3">
              <Clock className="h-4 w-4 mt-0.5 text-[#C8102E] shrink-0" />
              <span>{COMPANY.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="mt-14 pt-6 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} RNS Automobiles. All rights reserved.
          Proprietor: {COMPANY.owner}.
        </p>
        <div className="flex items-center gap-5 text-xs text-muted-foreground">
          <a href="#" className="hover:text-foreground transition-colors">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-foreground transition-colors">
            Terms & Conditions
          </a>
        </div>
      </div>
    </div>
  </footer>
);
